export const GiftBoxTopIcon = () => {
  return (
    <svg className="box-top" width="16" height="7" viewBox="0 0 16 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6.36841L15.3158 6.36841" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M5.68577 5.79268C7.0035 5.79268 8.07173 4.7198 8.07173 3.39634C8.07173 2.07288 7.0035 1 5.68577 1C4.36804 1 3.2998 2.07288 3.2998 3.39634C3.2998 4.7198 4.36804 5.79268 5.68577 5.79268Z"
        stroke="currentColor"
      />
      <path
        d="M10.9282 5.79268C12.2459 5.79268 13.3142 4.7198 13.3142 3.39634C13.3142 2.07288 12.2459 1 10.9282 1C9.61047 1 8.54224 2.07288 8.54224 3.39634C8.54224 4.7198 9.61047 5.79268 10.9282 5.79268Z"
        stroke="currentColor"
      />
    </svg>
  );
};
